module.exports = __webpack_public_path__ + "img/view_control.17fd4b26.png";